import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'extra-fields-list',
  template: require('./extra.fields.list.component.html'),
})
export class ExtraFieldsListComponent implements OnInit {
  @Input() tracker: any;
  @Input() extraFields: any;
  @Input() errors: any;
  @Input() canUpdate: boolean;
  @Input() fieldValidationMode: boolean;
  @Input() version: any;
  @Input() isNewTrackerItem: boolean;
  @Input() acls: any;

  displayFields: any[];
  workflow: any;
  isLoaded: boolean = false;

  constructor() {}

  ngOnInit() {
    this.displayFields = _.sortBy(this.extraFields, 'fieldOrder');
    this.workflow = _.get(this.tracker, 'rel.workflow', {});

    if (_.isEmpty(this.acls)) {
      this.acls = {};
    }

    if (this.fieldValidationMode) {
      this.displayFields = this.displayFields.filter((field) =>
        _.get(this.errors, field.alias + '.hasError', false)
      );
    }

    this.isLoaded = true;
  }

  hasError(alias) {
    return _.get(this.errors, alias + '.hasError', false);
  }

  isFieldEnabled(field: any): boolean {
    if (!field || !this.tracker || !this.tracker.fields) {
        return false;
    }
    const trackerField = this.tracker.fields[field.alias];
    return trackerField && trackerField.isExtraField && trackerField.isEnabled && 
          (field.id > 0 || trackerField.showOnSubmit);
  }

}
